import Stats from 'stats.js'
import EventEmitter from './EventEmitter'

export default class Time extends EventEmitter
{
    constructor(_options)
    {
        super()

        this.debug = _options.debug

        this.start = Date.now()
        this.current = this.start
        this.elapsed = 0
        this.delta = 16

        this.setStats()

        this.tick = this.tick.bind(this)
        this.tick()
    }

    tick()
    {
        if(this.debug.showStats) this.stats.begin()

        this.ticker = window.requestAnimationFrame(this.tick)

        const current = Date.now()

        this.delta = Math.min(current - this.current, 60)
        this.elapsed = (current - this.start) * 0.001
        this.current = current

        this.trigger('tick')

        if(this.debug.showStats) this.stats.end()
    }

    setStats()
    {
        if(this.debug.showStats)
        {
            this.stats = new Stats()
            this.stats.showPanel(0)
            this.stats.domElement.style.position = 'relative'
            document.querySelector('#statsjs_div').appendChild(this.stats.domElement)
        }
    }
}